import { affiliateTypeOptions } from "@/lib/affiliateOptions";
import { StepShell } from "./ui";
import type { AffiliateType } from "@/types";

interface StepTipoProps {
  value: "" | AffiliateType;
  error?: string;
  onChange: (value: AffiliateType) => void;
}

export default function StepTipo({ value, error, onChange }: StepTipoProps) {
  return (
    <StepShell
      title="¿Cómo quieres formar parte?"
      description="Elige una opción para mostrar el formulario correspondiente. Este registro es una solicitud para unirte a la red de colaboradores de AXONIA GROUP y queda sujeto a revisión."
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {affiliateTypeOptions.map((option) => {
          const selected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              aria-pressed={selected}
              className={`group flex cursor-pointer flex-col items-start rounded-lg border p-5 text-left transition-all duration-200 ${
                selected
                  ? "border-primary-400 bg-primary-50 ring-2 ring-primary-100"
                  : "border-background-200 bg-background-50 hover:border-primary-300"
              }`}
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-md ${
                  selected ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={`${option.icon} text-xl leading-none`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-heading font-semibold text-foreground-950">
                {option.label}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                {option.description}
              </p>
              <span
                className={`mt-4 inline-flex items-center gap-1.5 text-sm font-label font-semibold ${
                  selected ? "text-primary-700" : "text-foreground-500"
                }`}
              >
                <i
                  className={`${selected ? "ri-checkbox-circle-fill" : "ri-checkbox-blank-circle-line"} text-base leading-none`}
                  aria-hidden="true"
                ></i>
                {selected ? "Seleccionado" : "Seleccionar"}
              </span>
            </button>
          );
        })}
      </div>
      {error && (
        <p className="mt-3 flex items-center gap-1 text-xs text-primary-700">
          <i className="ri-error-warning-line text-sm leading-none" aria-hidden="true"></i>
          {error}
        </p>
      )}
    </StepShell>
  );
}